export const MESSAGE_EVENT_NAME = "mova::message";